/* INDIGREY — hero slideshow video: play the copy the shopper sees, and
   keep it playing.

   ROOT CAUSES of the frozen hero:
   1) The slideshow initialises Swiper with loop:true, and loop mode CLONES
      the slide — the hero <video> exists more than once, the clones are
      created AFTER page scripts run, and cloneNode strips JS listeners —
      so any one-shot fix misses them. A clone can be the visible copy: it
      sits frozen on its first frame while a hidden original plays.
   2) Legacy theme scripts repeatedly pause hero video (symptom: video
      runs while the shopper is touching — interaction handlers replay it —
      and freezes the moment they let go).

   This override runs CONTINUOUSLY (1.2s sweep): it adopts every hero
   video copy whenever it appears — originals and late-created Swiper
   clones alike (adoption is tracked with a JS expando, which clones do
   NOT inherit, unlike data-attributes) — and for each one:
   • picks a proper rendition (best available mp4 for the device; SD on
     slow/data-saver connections);
   • shields it: programmatic pause() is ignored while the hero is on
     screen, and unstoppable pauses recover within ~0.4s;
   • replays on canplay, stall, interaction, and tab-visible.
   Pausing still happens naturally when the hero is scrolled away or the
   tab is hidden — no battery tax. */
(function () {
  var wantMobile = !window.matchMedia('(min-width: 768px)').matches;
  var conn = navigator.connection || {};
  var slow = conn.saveData || /(slow-2g|2g|3g)/.test(conn.effectiveType || '');
  var PREFERRED = slow ? ['SD-480p'] : (wantMobile ? ['HD-720p', 'HD-1080p', 'SD-480p'] : ['HD-1080p', 'HD-720p', 'SD-480p']);

  function variantOK(v) {
    var isMobileVid = v.classList.contains('hero-video-mobile');
    return wantMobile ? isMobileVid : !isMobileVid;
  }

  function onScreen(v) {
    if (document.hidden) return false;
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
  }

  function pickSource(v) {
    var sources = v.querySelectorAll('source');
    if (!sources.length) return;
    var byName = {};
    var fallback = '';
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i].src || '';
      if (s.indexOf('.mp4') === -1) continue;
      if (!fallback) fallback = s;
      for (var k = 0; k < PREFERRED.length; k++) {
        if (s.indexOf(PREFERRED[k]) !== -1) byName[PREFERRED[k]] = s;
      }
    }
    var target = '';
    for (var k2 = 0; k2 < PREFERRED.length; k2++) {
      if (byName[PREFERRED[k2]]) { target = byName[PREFERRED[k2]]; break; }
    }
    if (!target) target = fallback;
    if (target && v.currentSrc !== target) { v.src = target; }
  }

  function tryPlay(v) {
    v.muted = true;
    var p = HTMLMediaElement.prototype.play.call(v);
    if (p && p.catch) { p.catch(function () {}); }
  }

  function adopt(v) {
    if (v._igHeroFixed) return;   /* expando — NOT copied by cloneNode */
    v._igHeroFixed = true;
    pickSource(v);
    v.setAttribute('preload', 'auto');
    v.setAttribute('autoplay', '');
    try { v.load(); } catch (e) {}
    var nativePause = HTMLMediaElement.prototype.pause.bind(v);
    v.pause = function () {
      if (!onScreen(v)) nativePause();
    };
    v.addEventListener('pause', function () {
      if (onScreen(v)) {
        clearTimeout(v._igResumeT);
        v._igResumeT = setTimeout(function () {
          if (v.paused && onScreen(v)) tryPlay(v);
        }, 400);
      }
    });
    v.addEventListener('canplay', function () { if (v.paused && onScreen(v)) tryPlay(v); });
    v.addEventListener('stalled', function () { if (onScreen(v)) tryPlay(v); });
    tryPlay(v);
  }

  function sweep() {
    var vids = document.querySelectorAll('.hero-video');
    for (var i = 0; i < vids.length; i++) {
      if (variantOK(vids[i])) {
        adopt(vids[i]);
        if (vids[i].paused && onScreen(vids[i])) tryPlay(vids[i]);
      }
    }
  }

  function boot() {
    sweep();
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, sweep, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sweep();
    });
    setInterval(sweep, 1200);
    window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
